import React, { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogContentText, DialogTitle, Grid, Button } from '@mui/material';
import colors from '../../colors';
import { texts } from '../texts';
import { useDispatch, useSelector } from 'react-redux';
import { selectLoginState, showLoggedDevicesDialog } from '../../../features/login/loginSlice';
import { sendGeneralRequest } from '../../../features/generalRequest';
import OTPInput from "otp-input-react";
import { useFormik } from 'formik'
import * as yup from 'yup'
import { makeStyles } from '@mui/styles';
import { setGlobalDataAccountType, setIsLoggedIn, setToken } from '../../../features/global/globalDataSlice';
import QRCode from 'react-qr-code';

const validationSchema = yup.object({
    otp: yup
        .string()
        .length(6)
        .required()
});

export const LoggedDevicesDialog = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const loginSlice = useSelector(selectLoginState)
    const isOpen = loginSlice.showLoggedDevices
    const [selectedDevice, setSelectedDevice] = useState(null)
    const [showSecondView, setShowSecondView] = useState(false)
    const formik = useFormik({
        initialValues: {
            otp: ''
        },
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            dispatch(sendGeneralRequest({ request: { request: { otp: values.otp, deviceId: selectedDevice.deviceId, token: loginSlice.scaToken } }, baseUrlKey: 'auth', endpoint: 'ConfirmFromAnotherDevice' }))
                .then(response => {
                    if (response.payload?.response?.success) {
                        dispatch(setToken(response.payload.response.token))
                        dispatch(setIsLoggedIn(true))
                        navigate('/dashboard')
                    }
                    resetForm();
                })
        }
    })

    const handleClose = () => {
        dispatch(showLoggedDevicesDialog(false))
        setShowSecondView(false)
    };

    const startConfirmationFromRegisteredDevice = (device) => {
        setSelectedDevice(device)
        dispatch(sendGeneralRequest({ request: { request: { deviceId: device.deviceId, token: loginSlice.scaToken } }, baseUrlKey: 'auth', endpoint: 'startConfirmationFromRegisteredDevice' }))
            .then(response => {
                if (response.payload.response.success) {
                    setShowSecondView(true)
                }
            })
    }

    const handleOtpChange = (otp) => {
        formik.setFieldValue('otp', otp)
    }

    const useStyles = makeStyles({
        button: {
            background: colors.gradientOrange,
            color: colors.white,
            width: '30%',
            fontFamily: 'GerberaBold',
            textTransform: 'none',
            fontSize: '1rem',
            '@media (max-width: 899px)': { width: '40%' }
        }
    })

    const classes = useStyles()

    return (
        <>
            <Grid>
                <Dialog
                    open={isOpen}
                    onClose={handleClose}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    PaperProps={{
                        style: {
                            borderRadius: '20px'
                        },
                    }}
                >
                    <DialogTitle id="scroll-dialog-title" sx={{ textAlign: 'center', background: colors.gradientOrange, color: colors.white, fontSize: '1.1rem', fontFamily: 'GerberaBold' }}> {texts["title-logged-devices"]} </DialogTitle>
                    <DialogContent sx={{
                        textAlign: 'center',
                        padding: '20px',
                        fontFamily: 'GerberaLight',
                        fontSize: '0.8rem',
                        color: colors.darkBlue,
                    }}
                    >
                        {!showSecondView ? (
                            <Grid>
                                {loginSlice.registeredDevices && loginSlice.registeredDevices.length > 0 ? (
                                    <>
                                        <DialogContentText
                                            id="scroll-dialog-description"
                                            pt={'4%'}
                                            sx={{ fontSize: '0.8rem', color: colors.darkBlue, textAlign: 'center', fontFamily: "GerberaLight", fontWeight: 'bold', marginBottom: '30px' }}
                                        >
                                            {texts["message-choose-device"]}
                                        </DialogContentText>
                                        <ul style={{ listStyleType: 'none', alignItems: 'center', justifyContent: 'center', margin: '0px', paddingLeft: '20px', paddingRight: '20px' }}>
                                            {loginSlice.registeredDevices.map((device) => (
                                                <li key={device.deviceId} style={{ marginBottom: '15px', border: '1px solid lightGray', display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                                    onClick={() => startConfirmationFromRegisteredDevice(device)}
                                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = colors.lightOrange}
                                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                                >
                                                    <img src={device.deviceLogo} alt={'logo'} style={{ marginLeft: '10vw', marginRight: '10px', marginBottom: '10px', marginTop: '10px', width: '40px', height: '40px' }} />
                                                    <span style={{ marginBottom: '10px', marginTop: '10px' }}>{device.devicePlatform}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </>

                                ) : (
                                    <Grid container direction="column" alignItems="center" justifyContent="center" style={{ textAlign: 'center', marginTop: '20px' }}>
                                        <DialogContentText
                                            id="scroll-dialog-description"
                                            pt={'4%'}
                                            sx={{ fontSize: '0.8rem', color: colors.darkBlue, textAlign: 'center', fontFamily: "GerberaLight" }}
                                        >
                                            {texts["message-no-registered-device"]}
                                        </DialogContentText>
                                        <span style={{ fontSize: '0.8rem', fontWeight: 500, color: colors.darkBlue, marginBottom: '20px', marginTop: '15px' }}>
                                            Skano për të shkarkuar EasyPay App:
                                        </span>
                                        <QRCode style={{ height: "auto", maxWidth: "20%" }} value={'https://login.easypay.al/DownloadApp'} />
                                    </Grid>
                                )
                                }
                            </Grid>
                        ) :
                            (
                                <Grid
                                    container
                                    direction="column"
                                    alignItems="center"
                                    justifyContent="center"
                                    style={{ textAlign: 'center' }}
                                >
                                    <DialogContentText
                                        id="scroll-dialog-description"
                                        pt={'4%'}
                                        sx={{
                                            fontSize: '0.8rem',
                                            color: colors.darkBlue,
                                            textAlign: 'center',
                                            fontFamily: 'GerberaLight',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        {texts["message-put-otp"]}
                                    </DialogContentText>

                                    <span
                                        style={{
                                            fontSize: '0.75rem',
                                            fontWeight: 500,
                                            color: colors.gray,
                                            marginBottom: '20px',
                                            marginTop: '25px',
                                            maxWidth: '400px',
                                            textAlign: 'center',
                                        }}
                                    >
                                        Tek pajisja juaj e ruajtur, shkoni tek "Me teper - Siguria" dhe gjeneroni kodin nje perdorimesh per te vazhduar:
                                    </span>
                                    <form onSubmit={formik.handleSubmit} style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <Grid item style={{ margin: '30px' }}>
                                            <OTPInput
                                                inputStyles={{
                                                    borderTop: 'none',
                                                    borderLeft: 'none',
                                                    outline: 'none',
                                                    borderRight: 'none',
                                                    fontFamily: 'GerberaLight',
                                                    borderBottomColor: colors.orange,
                                                    color: colors.darkBlue,
                                                    fontSize: '1.5rem',
                                                    paddingBottom: '3%',
                                                    height: '68%',
                                                }}
                                                value={formik.values.otp}
                                                onChange={handleOtpChange}
                                                autoFocus
                                                OTPLength={6}
                                                otpType="number"
                                                disabled={false}
                                            />
                                        </Grid>

                                        <Grid container item md={12} xs={12} pt={3} justifyContent="center">
                                            <Button type="submit" className={classes.button}>
                                                {texts["button-confirm"]}
                                            </Button>
                                        </Grid>
                                    </form>
                                </Grid>

                            )
                        }
                    </DialogContent>
                </Dialog>
            </Grid>
        </>)
}
export default LoggedDevicesDialog